import { render } from "./alertdialog.vue?vue&type=template&id=688a2116&scoped=true"
import script from "./alertdialog.vue?vue&type=script&lang=js"
export * from "./alertdialog.vue?vue&type=script&lang=js"

import "./alertdialog.vue?vue&type=style&index=0&id=688a2116&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-688a2116"]])

export default __exports__